import {
  MasterdataEntityDefinition,
  MasterdataFilter,
  MasterdataQueryBody,
  MasterdataQueryOptions,
} from '../types/masterdata-entity-definition';

export const MASTERDATA_DEFAULT_PAGE_SIZE = 100;

/** Combines filters into a single tree: null/undefined entries are dropped,
 *  a single survivor is returned as-is, several are AND-grouped. */
export function combineMasterdataFilters(
  filters: (MasterdataFilter | null | undefined)[]
): MasterdataFilter | null {
  const present = filters.filter((f): f is MasterdataFilter => f != null);
  if (present.length === 0) return null;
  if (present.length === 1) return present[0];
  return { type: 'conditions', operator: 'AND', filters: present };
}

/** Builds the `/query` body: paging defaults, definition `defaultFilter` AND'ed with
 *  the caller's filter (`filter` key omitted when none). `searchTerm` is always a plain
 *  string ('' when empty — explicit null 400s); a filter with `supportsFilter: false` throws. */
export function buildMasterdataQueryBody<TDto>(
  definition: MasterdataEntityDefinition<TDto>,
  searchTerm: string | null | undefined,
  options: MasterdataQueryOptions = {}
): MasterdataQueryBody {
  const body: MasterdataQueryBody = {
    searchTerm: (searchTerm ?? '').trim(),
    limit: options.limit ?? MASTERDATA_DEFAULT_PAGE_SIZE,
    offset: options.offset ?? 0,
  };
  const filter = combineMasterdataFilters([
    ...(definition.defaultFilter ?? []),
    options.filter,
  ]);
  if (definition.supportsFilter === false) {
    if (filter)
      throw new Error(`masterdata entity '${definition.name}' does not accept filters`);
    return body;
  }
  if (filter) body.filter = filter;
  return body;
}
